import Statistic from "common/Statistic/Statistic";
import TextWithPrecisionAndIcon from "common/Text/TextWithPrecisionAndIcon";
import { ICON_TYPES } from "@shared/common/constants";
import usePricesSocket from "@shared/services/socket/usePricesSocket";
import {
  LanguageNameSpaces,
  PrecisionConfig,
  PrecisionType,
} from "@shared/types";
import { RootState } from "app/store";
import { CSSProperties } from "react";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

interface PriceStatisticProps {
  currentPrice?: number;
  coin?: string;
  exchange?: string;
  symbol?: string;
  precisionConfig?: PrecisionConfig;
  precisionSelector?: (state: RootState) => PrecisionConfig | undefined;
  precision?: number;
  style?: CSSProperties;
  className?: string;
}

const PriceStatistic = ({
  currentPrice,
  coin,
  precisionSelector,
  precisionConfig,
  exchange,
  symbol,
  precision,
  style,
  className,
}: PriceStatisticProps) => {
  const { socketPrice } = usePricesSocket(symbol, exchange);
  const { t } = useTypedTranslation(LanguageNameSpaces.TRADES);

  return (
    <Statistic
      className={className}
      title={t("statistics.current_price")}
      value={
        <TextWithPrecisionAndIcon
          text={socketPrice.value || currentPrice}
          precisionSelector={precisionSelector}
          precisionConfig={precisionConfig}
          precisionType={PrecisionType.PRICE}
          precisionCoin={coin}
          iconType={ICON_TYPES.COIN}
          coinOrExchangeName={coin}
          precision={precision}
        />
      }
      style={style}
    />
  );
};

export default PriceStatistic;
